module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-2-updated-629622a4efa6d6b94d6c6c12c9974313.webp";